const authorizationScopesFakes = {
    //External Party Example
    ['9be8c02e-7ad4-4e86-9609-062c95739ad9']: [
        { id: 'registration/customer/query/customerNumber' },
        { id: 'registration/customer/query/plateNumber' },
        { id: 'registration/customer/query/canSearchCustomer' },
        { id: 'registration/customer/view/basic' },
        { id: 'authorization/organizations/view' },
        { id: 'authorization/organizationRoles/view' },
        { id: 'authorization/organizationUsers/view' },
        { id: 'authorization/organizationPermissions/view' },
        { id: 'authorization/userOrganizationRoleGrants/view' },
        { id: 'authorization/userOrganizations/view' },
        { id: 'registration/widget/view/basic' },
    ],
    //"I0233-06"
    ['3cf25675-f7cd-5afa-8d08-356cf541cd84']: [
        { id: 'registration/customer/query/customerNumber' },
        { id: 'registration/customer/query/plateNumber' },
        { id: 'registration/customer/query/canSearchCustomer' },
        { id: 'registration/customer/view/basic' },
        { id: 'registration/customer/view/customerNumber' },
        { id: 'registration/customer/view/advanced' },
        { id: 'registration/widget/view/basic' },
        { id: 'registration/widget/view/yearColor' },
        { id: 'registration/widget/view/expiry' },
        { id: 'registration/customer/view/customerPhoto' },
        { id: 'authorization/organizations/view' },
        { id: 'authorization/organizationRoles/view' },
        { id: 'authorization/organizationUsers/view' },
        { id: 'authorization/organizationPermissions/view' },
        { id: 'authorization/userOrganizationRoleGrants/view' },
        { id: 'authorization/userOrganizations/view' },
        { id: 'registration/widget/edit/needsAttention' },
        { id: 'registration/widget/edit/registration' },
        { id: 'registration/transaction/view' },
        { id: 'registration/transaction/edit' },
        { id: 'shoppingCartBasic/view' },
        { id: 'shoppingCartBasic/edit' },
        { id: 'payment/add-multiple' },
        { id: 'intraday-report/get-transaction-report' },
        { id: 'intraday-report/view/basic' },
        { id: 'intraday-report/view/advanced' },
        { id: 'billingInquiry/account/view' },
    ],
    //"I0233-12"
    ['03d8e9ee-9d4f-547c-bdf0-ed64bebe8f68']: [
        { id: 'registration/customer/query/customerNumber' },
        { id: 'registration/customer/query/plateNumber' },
        { id: 'registration/customer/view/basic' },
        { id: 'registration/customer/view/customerNumber' },
        { id: 'registration/customer/view/advanced' },
        { id: 'registration/customer/query/canSearchCustomer' },
        { id: 'registration/widget/view/basic' },
        { id: 'registration/widget/view/yearColor' },
        { id: 'registration/widget/view/expiry' },
        { id: 'registration/customer/view/customerPhoto' },
        { id: 'authorization/organizations/view' },
        { id: 'authorization/organizationRoles/view' },
        { id: 'authorization/organizationUsers/view' },
        { id: 'authorization/organizationPermissions/view' },
        { id: 'authorization/userOrganizationRoleGrants/view' },
        { id: 'authorization/userOrganizations/view' },
        { id: 'registration/widget/edit/needsAttention' },
        { id: 'registration/widget/edit/registration' },
        { id: 'registration/transaction/view' },
        { id: 'registration/transaction/edit' },
        { id: 'shoppingCartBasic/view' },
        { id: 'shoppingCartBasic/edit' },
        { id: 'payment/add-multiple' },
        { id: 'registration/customer/query/bypassJustificationPriorToSearch' },
        { id: 'intraday-report/get-transaction-report' },
        { id: 'intraday-report/view/basic' },
        { id: 'intraday-report/view/advanced' },
        { id: 'billingInquiry/account/view' },
    ],
    //"I0236-15"
    ['92f32c21-ed69-5cf5-b881-11e18935d902']: [
        { id: 'registration/customer/query/customerNumber' },
        { id: 'registration/customer/query/plateNumber' },
        { id: 'registration/customer/query/canSearchCustomer' },
        { id: 'registration/customer/view/basic' },
        { id: 'registration/customer/view/customerNumber' },
        { id: 'registration/customer/view/advanced' },
        { id: 'registration/customer/query/bypassJustificationPriorToSearch' },
        { id: 'registration/widget/view/basic' },
        { id: 'registration/widget/view/yearColor' },
        { id: 'registration/widget/view/expiry' },
        { id: 'registration/customer/view/customerPhoto' },
        { id: 'authorization/organizations/view' },
        { id: 'authorization/organizationRoles/view' },
        { id: 'authorization/organizationUsers/view' },
        { id: 'authorization/organizationPermissions/view' },
        { id: 'authorization/userOrganizationRoleGrants/view' },
        { id: 'authorization/userOrganizations/view' },
        { id: 'registration/widget/edit/needsAttention' },
        { id: 'registration/widget/edit/registration' },
        { id: 'registration/transaction/view' },
        { id: 'registration/transaction/edit' },
        { id: 'shoppingCartBasic/view' },
        { id: 'shoppingCartBasic/edit' },
        { id: 'payment/add-multiple' },
        { id: 'intraday-report/get-transaction-report' },
        { id: 'intraday-report/view/basic' },
        { id: 'intraday-report/view/advanced' },
        { id: 'billingInquiry/account/view' },
    ],
    //"I0233-23"
    ['43685489-b502-5e9a-8223-f000fc7c35b5']: [
        { id: 'registration/customer/query/customerNumber' },
        { id: 'registration/customer/query/plateNumber' },
        { id: 'registration/customer/query/canSearchCustomer' },
        { id: 'registration/customer/view/basic' },
        { id: 'registration/customer/view/customerNumber' },
        { id: 'registration/customer/view/advanced' },
        { id: 'registration/widget/view/basic' },
        { id: 'registration/widget/view/yearColor' },
        { id: 'registration/widget/view/expiry' },
        { id: 'registration/customer/view/customerPhoto' },
        { id: 'authorization/organizations/view' },
        { id: 'authorization/organizationRoles/view' },
        { id: 'authorization/organizationUsers/view' },
        { id: 'authorization/organizationPermissions/view' },
        { id: 'authorization/userOrganizationRoleGrants/view' },
        { id: 'authorization/userOrganizations/view' },
        { id: 'registration/widget/edit/needsAttention' },
        { id: 'registration/widget/edit/registration' },
        { id: 'registration/transaction/view' },
        { id: 'registration/transaction/edit' },
        { id: 'shoppingCartBasic/view' },
        { id: 'shoppingCartBasic/edit' },
        { id: 'payment/add-multiple' },
        { id: 'intraday-report/get-transaction-report' },
        { id: 'intraday-report/view/basic' },
        { id: 'intraday-report/view/advanced' },
        { id: 'billingInquiry/account/view' },
    ],
    //Regina Law Enforcement Service
    ['5da35ba7-7ac0-484a-ad7b-b43b5bf000e0']: [
        { id: 'registration/customer/query/customerNumber' },
        { id: 'registration/customer/query/plateNumber' },
        { id: 'registration/customer/query/canSearchCustomer' },
        { id: 'registration/customer/view/basic' },
        { id: 'authorization/organizations/view' },
        { id: 'authorization/organizationRoles/view' },
        { id: 'authorization/organizationUsers/view' },
        { id: 'authorization/organizationPermissions/view' },
        { id: 'authorization/userOrganizationRoleGrants/view' },
        { id: 'authorization/userOrganizations/view' },
        { id: 'registration/widget/view/basic' },
    ],
    //"SGI CANADA - NAGS" make equivalent of internal viewer with photo
    ['03712cae-d5f2-58d4-815d-9fc5d82c8ba6']: [
        {
            id: 'registration/customer/query/customerNumber',
        },
        {
            id: 'registration/customer/query/plateNumber',
        },
        { id: 'registration/customer/query/canSearchCustomer' },
        {
            id: 'registration/customer/view/basic',
        },
        {
            id: 'registration/customer/view/customerNumber',
        },
        {
            id: 'registration/customer/view/advanced',
        },
        {
            id: 'registration/widget/view/basic',
        },
        {
            id: 'registration/widget/view/yearColor',
        },
        {
            id: 'registration/widget/view/expiry',
        },
        {
            id: 'registration/customer/view/customerPhoto',
        },
        {
            id: 'authorization/organizations/view',
        },
        {
            id: 'authorization/organizationRoles/view',
        },
        {
            id: 'authorization/organizationUsers/view',
        },
        {
            id: 'authorization/organizationPermissions/view',
        },
        {
            id: 'authorization/userOrganizationRoleGrants/view',
        },
        {
            id: 'authorization/userOrganizations/view',
        },
        {
            id: 'registration/widget/edit/needsAttention',
        },
        {
            id: 'registration/widget/edit/registration',
        },
        {
            id: 'registration/transaction/view',
        },
        {
            id: 'registration/transaction/edit',
        },
        {
            id: 'authorization/organizations/view',
        },
        {
            id: 'authorization/organizationRoles/view',
        },
        {
            id: 'authorization/organizationUsers/view',
        },
        {
            id: 'authorization/organizationPermissions/view',
        },
        {
            id: 'authorization/userOrganizationRoleGrants/view',
        },
        {
            id: 'authorization/userOrganizations/view',
        },
        {
            id: 'registration/cancellation/view/advanced',
        },
        {
            id: 'registration/cancellation/edit/advanced',
        },
        {
            id: 'shoppingCartBasic/view',
        },
        {
            id: 'shoppingCartBasic/edit',
        },
        {
            id: 'payment/addMultiple',
        },
        {
            id: 'payment/authCode',
        },
        {
            id: 'authorization/all/administer',
        },
        {
            id: 'authorization/organizations/edit',
        },
        {
            id: 'authorization/organizationTemplates/view',
        },
        {
            id: 'authorization/organizationTemplates/edit',
        },
        {
            id: 'authorization/organizationRoles/edit',
        },
        {
            id: 'authorization/organizationUsers/edit',
        },
        {
            id: 'authorization/organizationPermissions/edit',
        },
        {
            id: 'authorization/permission/edit',
        },
        {
            id: 'authorization/permission/view',
        },
        {
            id: 'authorization/roles/edit',
        },
        {
            id: 'authorization/userOrganizationRoleGrants/edit',
        },
        {
            id: 'authorization/user/onboard',
        },
        {
            id: 'billingInquiry/account/view'
        },
    ],
    //SGI Canada Misc Claims Expenses
    ['bcdb54d3-c743-5257-a7fe-d936d69e0f44']: [
        { id: 'registration/customer/query/customerNumber' },
        { id: 'registration/customer/query/plateNumber' },
        { id: 'registration/customer/query/canSearchCustomer' },
        { id: 'registration/customer/view/basic' },
        { id: 'registration/customer/query/bypassJustificationPriorToSearch' },
        { id: 'registration/widget/view/basic' },
        { id: 'registration/widget/view/yearColor' },
        { id: 'registration/widget/view/expiry' },
        { id: 'billingInquiry/account/view' },
    ],
    //sgi head office
    ['4cbb6b59-e653-5ef3-9c25-97eb6470771c']: [
        {
            id: 'registration/customer/query/customerNumber',
        },
        {
            id: 'registration/customer/query/plateNumber',
        },
        { id: 'registration/customer/query/canSearchCustomer' },
        {
            id: 'registration/customer/view/basic',
        },
        {
            id: 'registration/customer/view/customerNumber',
        },
        {
            id: 'registration/customer/view/advanced',
        },
        {
            id: 'registration/widget/view/basic',
        },
        {
            id: 'registration/widget/view/yearColor',
        },
        {
            id: 'registration/widget/view/expiry',
        },
        {
            id: 'registration/customer/view/customerPhoto',
        },
        {
            id: 'authorization/organizations/view',
        },
        {
            id: 'authorization/organizationRoles/view',
        },
        {
            id: 'authorization/organizationUsers/view',
        },
        {
            id: 'authorization/organizationPermissions/view',
        },
        {
            id: 'authorization/userOrganizationRoleGrants/view',
        },
        {
            id: 'authorization/userOrganizations/view',
        },
        {
            id: 'registration/widget/edit/needsAttention',
        },
        {
            id: 'registration/widget/edit/registration',
        },
        {
            id: 'registration/transaction/view',
        },
        {
            id: 'registration/transaction/edit',
        },
        {
            id: 'authorization/organizations/view',
        },
        {
            id: 'authorization/organizationRoles/view',
        },
        {
            id: 'authorization/organizationUsers/view',
        },
        {
            id: 'authorization/organizationPermissions/view',
        },
        {
            id: 'authorization/userOrganizationRoleGrants/view',
        },
        {
            id: 'authorization/userOrganizations/view',
        },
        {
            id: 'registration/cancellation/view/advanced',
        },
        {
            id: 'registration/cancellation/edit/advanced',
        },
        {
            id: 'shoppingCartBasic/view',
        },
        {
            id: 'shoppingCartBasic/edit',
        },
        {
            id: 'payment/addMultiple',
        },
        {
            id: 'payment/authCode',
        },
        {
            id: 'authorization/all/administer',
        },
        {
            id: 'authorization/organizations/edit',
        },
        {
            id: 'authorization/organizationTemplates/view',
        },
        {
            id: 'authorization/organizationTemplates/edit',
        },
        {
            id: 'authorization/organizationRoles/edit',
        },
        {
            id: 'authorization/organizationUsers/edit',
        },
        {
            id: 'authorization/organizationPermissions/edit',
        },
        {
            id: 'authorization/permission/edit',
        },
        {
            id: 'authorization/permission/view',
        },
        {
            id: 'authorization/roles/edit',
        },
        {
            id: 'authorization/userOrganizationRoleGrants/edit',
        },
        {
            id: 'authorization/user/onboard',
        },
        {
            id: 'registration/scanOverride/view/reason',
        },
        { id: 'registration/transaction/view/issuerCode' },
        { id: 'registration/cancellation/view/headOfficeReason' },
        { id: 'registration/cancellation/query/canCancelWip' },
        { id: 'registration/cancellation/edit/canWaiveCancelFee' },
        { id: 'registration/cancellation/edit/canBackDate' },
        { id: 'registration/customer/query/bypassJustificationPriorToSearch' },
        { id: 'intraday-report/get-transaction-report' },
        { id: 'intraday-report/view/basic' },
        { id: 'intraday-report/view/advanced' },
        { id: 'billingInquiry/account/view' },
    ],
    //"Underwriter Example"
    ['fc8406c5-2cf1-47db-8ba7-6f58701e993e']: [
        { id: 'registration/customer/query/customerNumber' },
        { id: 'registration/customer/query/plateNumber' },
        { id: 'registration/customer/view/basic' },
        { id: 'registration/customer/query/bypassJustificationPriorToSearch' },
        { id: 'registration/widget/view/basic' },
        { id: 'registration/widget/view/yearColor' },
        { id: 'registration/widget/view/expiry' },
    ],
};
export { authorizationScopesFakes };
